import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/home/partners')({
  staticData: { team: 'fe-ux-platform' },
});
